export class SurveyDeployerPageResponseJSON {
    surveyID: Number;
    userID: Number;
    tenantID: Number;
    contextEntityId: Number;
    contextInstanceId: Number;
    roleID: Number;
    sysSurveyRunID: Number;
}